import { AnimatePresence } from 'motion/react';

import { useNotification } from '@hooks/useNotification';

import { BelowHeaderNotification } from './BelowHeaderNotification';
import { HeaderNotification } from './HeaderNotification';

export function NotificationContainer() {
  const { notifications, dismissNotification } = useNotification();

  // Separate notifications by position
  const topNotifications = notifications.filter(n => n.position === 'top');
  const belowHeaderNotifications = notifications.filter(
    n => n.position === 'below-header',
  );

  return (
    <>
      {/* Top notifications (header style) */}
      <AnimatePresence>
        {topNotifications.map(notification => (
          <HeaderNotification
            key={notification.id}
            isOpen={true}
            onClose={() => dismissNotification(notification.id)}
            message={String(notification.message)}
            type={
              notification.type === 'confetti' ? 'success' : notification.type
            }
            duration={0} // Controlled by context
          />
        ))}
      </AnimatePresence>

      {/* Below-header notifications (with frog, glassy black) - stacked */}
      <div className="fixed top-[115px] left-0 right-0 z-[9998] flex flex-col items-center gap-2 px-4 pointer-events-none">
        <AnimatePresence initial={false}>
          {belowHeaderNotifications.map(notification => (
            <BelowHeaderNotification
              key={notification.id}
              isOpen={true}
              onClose={() => dismissNotification(notification.id)}
              message={notification.message}
              type={notification.type}
              tradeType={
                (notification.metadata?.tradeType as 'CALL' | 'PUT') ?? 'CALL'
              }
              showConfetti={notification.type === 'confetti'}
              leftContent={notification.leftContent}
            />
          ))}
        </AnimatePresence>
      </div>
    </>
  );
}
